import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import PublicPageLayout from '../../../layout/PublicPageLayout';
import PageHeader from '../../../layout/PageHeader';
import PageMainContent from '../../../layout/PageMainContent';
import { LOGO_SIZE } from '../../../ui/Logo';
import Loader from '../../../ui/Loader';
import { formatLangCode } from '../../../helpers';
import { useNoIndex } from '../../../hooks/noIndex';
import { useCreatorManual } from './useCreatorManual';
import { useManualNavigation } from './useManualNavigation';
import ManualToc from './ManualToc';
import ManualChapter from './ManualChapter';
// Hidden help page: reachable only via direct link (and the creator area footer), not indexed.
// Content comes from content/<lang>.json, generated by the TYPO3 creator manual import.
const CreatorManualPage = () => {
    const { t, i18n } = useTranslation();
    useNoIndex();
    const contentRef = useRef(null);
    const manualState = useCreatorManual(formatLangCode(i18n.language));
    const manual = manualState.status === 'ready' && manualState.manual.chapters.length > 0
        ? manualState.manual
        : null;
    useManualNavigation(contentRef, manual !== null);
    let body;
    if (manualState.status === 'loading') {
        body = (_jsx("div", { className: "creator-manual-status", children: _jsx(Loader, {}) }));
    }
    else if (manualState.status === 'error') {
        body = (_jsx("p", { className: "creator-manual-status creator-manual-status--error", children: t('creator_manual.error') }));
    }
    else if (!manual) {
        body = _jsx("p", { className: "creator-manual-status", children: t('creator_manual.unavailable') });
    }
    else {
        body = (_jsxs(_Fragment, { children: [_jsx(ManualToc, { chapters: manual.chapters }), manual.chapters.map((chapter) => (_jsx(ManualChapter, { chapter: chapter }, chapter.id)))] }));
    }
    return (_jsx(PublicPageLayout, { children: _jsxs("div", { className: "page-content-wrapper creator-manual-page", children: [_jsx(PageHeader, { logoSize: LOGO_SIZE.FULL, logoLink: "/" }), _jsx(PageMainContent, { children: _jsxs("div", { ref: contentRef, className: "creator-manual-content", lang: manual?.language, children: [_jsx("h1", { className: "creator-manual-title", children: manual?.title || t('creator_manual.title') }), body] }) })] }) }));
};
export default CreatorManualPage;
